/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} FasInputs */

const en_fas = /** @type {(inputs: FasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAS`)
};

const nl_fas = /** @type {(inputs: FasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAS`)
};

/**
* | output |
* | --- |
* | "FAS" |
*
* @param {FasInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const fas = /** @type {((inputs?: FasInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<FasInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_fas(inputs)
	return en_fas(inputs)
});